import React, {Component} from 'react';
import T from "i18n-react/dist/i18n-react";
import {
    FormRow,
    FormField,
    FormInput,
    FormSelect,
    Checkbox,
    Row,
    Col,
    Card,
    Button,
    InputGroup
} from 'elemental-react16';
import '../../node_modules/elemental-react16/less/elemental.less';
//import countries from '../countries.json';
//import {FormErrors} from './FormErrors';
import Autocomplete from 'react-google-autocomplete';
import trim from 'trim';


class CompleteOrder extends Component {

    constructor(props) {
        super(props);

        this.state = {
            addedAddressCheck: true,
            acceptPrivacyAddress1Check: false,
            acceptPrivacyAddress2Check: false,
            firstName: '',
            lastName: '',
            businessName: '',
            phone: '',
            email: '',
            vatNumber: '',
            address1: '',
            address2: '',
            zip: '',
            city: '',
            stateOrProvince: '',
            formErrors: {
                firstName: '',
                lastName: '',
                phone: '',
                email: '',
                vatNumber: '',
                address1: '',
                zip: '',
                city: '',
                stateOrProvince: ''
            },
            firstNameValid: false,
            lastNameValid: false,
            phoneValid: false,
            emailValid: false,
            vatNumberValid: false,
            address1Valid: false,
            zipValid: false,
            cityValid: false,
            stateOrProvinceValid: false,
            formValid: false,
            address1Billing: '',
            address2Billing: '',
            zipBilling: '',
            cityBilling: '',
            stateOrProvinceBilling: '',
            formErrorsBilling: {
                address1Billing: '',
                zipBilling: '',
                cityBilling: '',
                stateOrProvinceBilling: ''
            },
            address1ValidBilling: false,
            zipValidBilling: false,
            cityValidBilling: false,
            stateOrProvinceValidBilling: false,
            formValidBilling: false,
            orderDone: false
        }
    }

    handleNormalInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({[name]: value});
    };

    handleUserInput = (e, customName) => {
        const name = e.target.name;
        let value = e.target.value;
        const label = customName;

        if (name !== 'address1' && name !== 'firstName' && name !== 'lastName' && name !== 'city' && name !== 'stateOrProvince' && name !== 'businessName') {
            value = trim(value);
        }

        this.setState({[name]: value},
            () => {
                this.validateField(name, value, label)
            });
    };

    handleUserInputBilling = (e, customName) => {
        const name = e.target.name;
        const value = e.target.value;
        const label = customName;
        this.setState({[name]: value},
            () => {
                this.validateFieldBilling(name, value, label)
            });
    };

    validateField = (fieldName, value, label) => {
        let fieldValidationErrors = this.state.formErrors;
        let firstNameValid = this.state.firstNameValid;
        let lastNameValid = this.state.lastNameValid;
        let phoneValid = this.state.phoneValid;
        let emailValid = this.state.emailValid;
        let vatNumberValid = this.state.vatNumberValid;
        let address1Valid = this.state.address1Valid;
        let zipValid = this.state.zipValid;
        let cityValid = this.state.cityValid;
        let stateOrProvinceValid = this.state.stateOrProvinceValid;

        let commonCondition = (value.length >= 2);
        let commonError = label + T.translate("labels.isRequired");

        switch (fieldName) {
            case 'email':
                emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) && commonCondition;
                fieldValidationErrors.email = emailValid ? '' : label + T.translate("labels.isInvalid");
                break;
            case 'firstName':
                firstNameValid = commonCondition;
                fieldValidationErrors.firstName = firstNameValid ? '' : commonError;
                break;
            case 'lastName':
                lastNameValid = commonCondition;
                fieldValidationErrors.lastName = lastNameValid ? '' : commonError;
                break;
            case 'phone':
                phoneValid = (value.length >= 6);
                fieldValidationErrors.phone = phoneValid ? '' : label + T.translate("labels.phoneMinLength");
                break;
            case 'vatNumber':
                vatNumberValid = (value.length >= 8);
                fieldValidationErrors.vatNumber = vatNumberValid ? '' : label + T.translate("labels.vatNumberMinLength");
                break;
            case 'address1':
                address1Valid = commonCondition;
                fieldValidationErrors.address1 = address1Valid ? '' : commonError;
                break;
            case 'zip':
                zipValid = (value.length >= 4);
                fieldValidationErrors.zip = zipValid ? '' : label + T.translate("labels.zipMinLength");
                break;
            case 'city':
                cityValid = commonCondition;
                fieldValidationErrors.city = cityValid ? '' : commonError;
                break;
            case 'stateOrProvince':
                stateOrProvinceValid = commonCondition;
                fieldValidationErrors.stateOrProvince = stateOrProvinceValid ? '' : commonError;
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            firstNameValid: firstNameValid,
            lastNameValid: lastNameValid,
            phoneValid: phoneValid,
            emailValid: emailValid,
            vatNumberValid: vatNumberValid,
            address1Valid: address1Valid,
            zipValid: zipValid,
            cityValid: cityValid,
            stateOrProvinceValid: stateOrProvinceValid
        }, this.validateForm);
    };

    validateFieldBilling = (fieldName, value, label) => {
        let fieldValidationErrors = this.state.formErrorsBilling;
        let address1Valid = this.state.address1ValidBilling;
        let zipValid = this.state.zipValidBilling;
        let cityValid = this.state.cityValidBilling;
        let stateOrProvinceValid = this.state.stateOrProvinceValidBilling;

        let commonCondition = (value.length >= 2);
        let commonError = label + T.translate("labels.isRequired");

        switch (fieldName) {
            case 'address1Billing':
                address1Valid = commonCondition;
                fieldValidationErrors.address1Billing = address1Valid ? '' : commonError;
                break;
            case 'zipBilling':
                zipValid = (value.length >= 4);
                fieldValidationErrors.zipBilling = zipValid ? '' : label + T.translate("labels.zipMinLength");
                break;
            case 'cityBilling':
                cityValid = commonCondition;
                fieldValidationErrors.cityBilling = cityValid ? '' : commonError;
                break;
            case 'stateOrProvinceBilling':
                stateOrProvinceValid = commonCondition;
                fieldValidationErrors.stateOrProvinceBilling = stateOrProvinceValid ? '' : commonError;
                break;
            default:
                break;
        }
        this.setState({
            formErrorsBilling: fieldValidationErrors,
            address1ValidBilling: address1Valid,
            zipValidBilling: zipValid,
            cityValidBilling: cityValid,
            stateOrProvinceValidBilling: stateOrProvinceValid
        }, this.validateFormBilling);
    };

    validateForm = () => {
        this.setState({
            formValid:
            this.state.firstNameValid &&
            this.state.lastNameValid &&
            this.state.phoneValid &&
            this.state.emailValid &&
            this.state.vatNumberValid &&
            this.state.address1Valid &&
            this.state.zipValid &&
            this.state.cityValid &&
            this.state.stateOrProvinceValid
        });
    };

    validateFormBilling = () => {
        this.setState({
            formValidBilling:
            this.state.address1ValidBilling &&
            this.state.zipValidBilling &&
            this.state.cityValidBilling &&
            this.state.stateOrProvinceValidBilling
        });
    };

    handleCheckboxInput = (e) => {
        this.setState({
            [e.target.name]: e.target.checked
        })
    };

    errorClass = (error) => {
        return (error.length === 0 ? '' : 'is-invalid');
    };

    errorLabel = (val) => {
        return val.length > 0 && <div className="form-validation is-invalid">{val}</div>
    };

    capFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    toNumeric = (number) => {
        return number.replace(/\D/g,'');
    };

    saveDataShipping = () => {
        let postId = this.props.postId,
            userSessionId = this.props.userSessionId,
            _self = this;

        this.props.ordersInstance
            .child(postId)
            .child(userSessionId)
            .update({
                shippingData: {
                    firstName:          this.state.firstName,
                    lastName:           this.state.lastName,
                    businessName:       this.state.businessName,
                    phone:              `+39${this.state.phone}`,
                    email:              this.state.email,
                    vatNumber:          this.state.vatNumber,
                    address1:           this.state.address1,
                    address2:           this.state.address2,
                    //country:            this.props.country,
                    zip:                this.state.zip,
                    city:               this.state.city,
                    state:              this.state.stateOrProvince,
                    billingAddressFlag: this.state.addedAddressCheck,
                    address1Billing:    this.state.address1Billing,
                    address2Billing:    this.state.address2Billing,
                    //countryBilling:     this.props.country,
                    zipBilling:         this.state.zipBilling,
                    cityBilling:        this.state.cityBilling,
                    stateBilling:       this.state.stateOrProvinceBilling,
                    promotionAccept:    this.state.acceptPrivacyAddress2Check
                },
                isOrderDone: true
            }).then(() => {
                let emailFields = {
                    firstName:          this.state.firstName,
                    lastName:           this.state.lastName,
                    address1:           this.state.address1,
                    address2:           this.state.address2,
                    zip:                this.state.zip,
                    city:               this.state.city,
                    state:              this.state.stateOrProvince,
                    userSessionId:      userSessionId,
                    email:              this.state.email,
                    locale:             this.props.locale
                };

                _self.props.handleOrderCompleted(emailFields);
            });
    };

    handleOnPlaceSelectedShippingAddr = (place) => {
        let fullAddress = place.address_components;
        fullAddress &&
        this.setState({
            address1: `${fullAddress[1].short_name}, ${fullAddress[0].short_name}`,
            zip: fullAddress[7] ? fullAddress[7].short_name : '',
            city: fullAddress[3] ? fullAddress[3].short_name : '',
            stateOrProvince: fullAddress[4] ? fullAddress[4].short_name : '',
            address1Valid: true,
            zipValid: !!fullAddress[7],
            cityValid: !!fullAddress[3],
            stateOrProvinceValid: !!fullAddress[4]
        }, this.validateForm);
    };

    handleOnPlaceSelectedBillingAddr = (place) => {
        let fullAddress = place.address_components;
        fullAddress &&
        this.setState({
            address1Billing: `${fullAddress[1].short_name}, ${fullAddress[0].short_name}`,
            zipBilling: fullAddress[7] ? fullAddress[7].short_name : '',
            cityBilling: fullAddress[3] ? fullAddress[3].short_name : '',
            stateOrProvinceBilling: fullAddress[4] ? fullAddress[4].short_name : '',
            address1ValidBilling: true,
            zipValidBilling: !!fullAddress[7],
            cityValidBilling: !!fullAddress[3],
            stateOrProvinceValidBilling: !!fullAddress[4]
        }, this.validateFormBilling);
    };

    render() {

        //let country = this.props.country ? this.props.country : T.translate("labels.selectYourCountry");

        let errFirstName = this.state.formErrors.firstName;
        let errLastName = this.state.formErrors.lastName;
        let errPhone = this.state.formErrors.phone;
        let errEmail = this.state.formErrors.email;
        let errVatNumber = this.state.formErrors.vatNumber;
        let errAddress1 = this.state.formErrors.address1;
        let errZip = this.state.formErrors.zip;
        let errCity = this.state.formErrors.city;
        let errStateOrProvince = this.state.formErrors.stateOrProvince;

        let errAddress1Billing = this.state.formErrorsBilling.address1Billing;
        let errZipBilling = this.state.formErrorsBilling.zipBilling;
        let errCityBilling = this.state.formErrorsBilling.cityBilling;
        let errStateOrProvinceBilling = this.state.formErrorsBilling.stateOrProvinceBilling;

        return (
            <Card className="address-modal">
                <Row className="order-confirmed" xs="90%" sm="100%" lg="100%">
                    <Col>
                        <div className="address-view-icon">
                            <i className="fas fa-shipping-fast" />
                        </div>

                        <h3>
                            {T.translate("labels.addressFilling")}
                        </h3>
                        <hr/>
                        <h5 style={{lineHeight: 1.3}}>
                            {T.translate("labels.fillingForm")}
                            <span className="required" style={{color: '#FF5F5F'}}>
                                {T.translate("labels.fillingFormClause")}
                            </span>
                        </h5><br/>

                        <FormRow>
                            <FormField width="one-half"
                                       label={`${T.translate("labels.firstName")} *`}
                                       htmlFor="first-name"
                                       className={`${this.errorClass(errFirstName)}`}>
                                <FormInput name="firstName"
                                           value={this.capFirstLetter(this.state.firstName)}
                                           onChange={e => this.handleUserInput(e, T.translate("labels.firstName"))}/>
                                {this.errorLabel(errFirstName)}
                            </FormField>
                            <FormField width="one-half"
                                       label={`${T.translate("labels.lastName")} *`}
                                       htmlFor="last-name"
                                       className={`${this.errorClass(errLastName)}`}>
                                <FormInput name="lastName"
                                           value={this.capFirstLetter(this.state.lastName)}
                                           onChange={e => this.handleUserInput(e, T.translate("labels.lastName"))}/>
                                {this.errorLabel(errLastName)}
                            </FormField>
                        </FormRow>

                        <FormRow>
                            <FormField style={{width: '100%'}} label={`${T.translate("labels.businessName")}`}>
                                <FormInput name="businessName"
                                           value={this.state.businessName}
                                           onChange={e => this.handleUserInput(e, T.translate("labels.businessName"))}/>
                            </FormField>
                        </FormRow>

                        <FormRow>
                            <FormField width="one-half"
                                       label={`${T.translate("labels.phone")} *`}
                                       htmlFor="phone"
                                       className={`${this.errorClass(errPhone)}`}>
                                <InputGroup contiguous>
                                    <InputGroup.Section>
                                        <Button disabled={true}>+39</Button>
                                    </InputGroup.Section>
                                    <InputGroup.Section grow>
                                        <FormInput name="phone"
                                                   className="phone-input"
                                                   value={this.toNumeric(this.state.phone)}
                                                   onChange={e => this.handleUserInput(e, T.translate("labels.phone"))}
                                                   placeholder={T.translate("labels.phonePlaceholder")}/>
                                        {this.errorLabel(errPhone)}
                                    </InputGroup.Section>
                                </InputGroup>
                            </FormField>
                            <FormField width="one-half"
                                       label={`${T.translate("labels.email")} *`}
                                       htmlFor="email"
                                       className={`${this.errorClass(errEmail)}`}>
                                <FormInput name="email"
                                           value={this.state.email}
                                           onChange={(e) => this.handleUserInput(e, T.translate("labels.email"))}/>
                                {this.errorLabel(errEmail)}
                            </FormField>
                        </FormRow>

                        <FormRow>
                            <FormField style={{width: '100%'}} label={`${T.translate("labels.vatNumber")} *`}
                                       className={`${this.errorClass(errVatNumber)}`}>
                                <FormInput name="vatNumber"
                                           value={this.state.vatNumber}
                                           onChange={e => this.handleUserInput(e, T.translate("labels.vatNumber"))}/>
                                {this.errorLabel(errVatNumber)}
                            </FormField>
                        </FormRow>

                        <FormRow>
                            <FormField width="two-thirds"
                                       label={`${T.translate("labels.address1")} *`}
                                       htmlFor="address-street1"
                                       className={`${this.errorClass(errAddress1)}`}>
                                <Autocomplete
                                    onPlaceSelected={(place) => {this.handleOnPlaceSelectedShippingAddr(place)}}
                                    className="FormInput"
                                    name="address1"
                                    value={this.state.address1}
                                    onChange={e => this.handleUserInput(e, T.translate("labels.address1"))}
                                    placeholder={T.translate("labels.address1Placeholder")}
                                    types={['address']} />
                                {this.errorLabel(errAddress1)}
                            </FormField>
                            <FormField width="one-third" label={T.translate("labels.address2")}>
                                <FormInput placeholder={T.translate("labels.address2Placeholder")}
                                           name="address2"
                                           value={this.state.address2}
                                           onChange={this.handleNormalInput}/>
                            </FormField>
                        </FormRow>

                        <FormRow>
                            <FormField width="two-thirds" label={`${T.translate("labels.country")} *`}>
                                <FormSelect options={[{"label": "Italy", "value": "it"}]}
                                            firstOption="Italia"
                                            disabled={true}
                                            value="it" onChange={this.handleNormalInput}/>
                            </FormField>
                            <FormField width="one-third" label={`${T.translate("labels.zip")} *`}
                                       className={`${this.errorClass(errZip)}`}>
                                <FormInput width="one-third" name="zip" value={this.state.zip}
                                           onChange={e => this.handleUserInput(e, T.translate("labels.zip"))}/>
                                {this.errorLabel(errZip)}
                            </FormField>
                            <FormField width="two-thirds" label={`${T.translate("labels.city")} *`}
                                       className={`${this.errorClass(errCity)}`}>
                                <FormInput name="city" value={this.capFirstLetter(this.state.city)}
                                           onChange={e => this.handleUserInput(e, T.translate("labels.city"))}/>
                                {this.errorLabel(errCity)}
                            </FormField>
                            <FormField width="one-third" label={`${T.translate("labels.state")} *`}
                                       className={`${this.errorClass(errStateOrProvince)}`}>
                                <FormInput name="stateOrProvince" value={this.capFirstLetter(this.state.stateOrProvince)}
                                           onChange={e => this.handleUserInput(e, T.translate("labels.state"))}/>
                                {this.errorLabel(errStateOrProvince)}
                            </FormField>
                            <FormField>
                                <Checkbox label={T.translate("labels.addedAddress")}
                                          defaultChecked={this.state.addedAddressCheck}
                                          onChange={this.handleCheckboxInput}
                                          name="addedAddressCheck"/>
                            </FormField>
                            <div style={{clear: 'both'}} />
                            <hr/>
                            <FormField>
                                <Checkbox defaultChecked={this.state.acceptPrivacyAddress1Check}
                                          onChange={this.handleCheckboxInput}
                                          name="acceptPrivacyAddress1Check"
                                          style={{float: 'left'}} />
                                <span className="label-checkbox">
                                    {T.translate("labels.acceptPrivacyAddress1")}
                                    <a href="http://www.bestwaycorp.it/Footer/Policy" target="_blank">{T.translate("labels.linkPrivacy")}</a>
                                    {T.translate("labels.acceptPrivacyAddress2")}
                                </span>
                            </FormField>
                            <div style={{clear: 'both'}} />
                            <hr/>
                            <FormField>
                                <Checkbox defaultChecked={this.state.acceptPrivacyAddress2Check}
                                          onChange={this.handleCheckboxInput}
                                          name="acceptPrivacyAddress2Check"
                                          style={{float: 'left'}} />
                                <span className="label-checkbox">
                                    <a href="http://www.bestwaycorp.it/Footer/Policy" target="_blank">{T.translate("labels.linkPrivacy1")}</a>
                                    {T.translate("labels.acceptPrivacyAddress3")}
                                </span>
                            </FormField>
                        </FormRow>

                        {/* Billing Address */}
                        {
                            !this.state.addedAddressCheck &&
                            <div>
                                <hr/>
                                <FormRow>
                                    <FormField width="two-thirds"
                                               label={`${T.translate("labels.address1")} *`}
                                               className={`${errAddress1Billing && this.errorClass(errAddress1Billing)}`}>

                                        <Autocomplete
                                            onPlaceSelected={(place) => {this.handleOnPlaceSelectedBillingAddr(place)}}
                                            className="FormInput"
                                            name="address1Billing"
                                            value={this.state.address1Billing}
                                            onChange={e => this.handleUserInputBilling(e, T.translate("labels.address1"))}
                                            placeholder={T.translate("labels.address1Placeholder")}
                                            types={['address']} />
                                        {errAddress1Billing && this.errorLabel(errAddress1Billing)}
                                    </FormField>
                                    <FormField width="one-third" label={T.translate("labels.address2")}>
                                        <FormInput placeholder={T.translate("labels.address2Placeholder")}
                                                   name="address2Billing"
                                                   value={this.state.address2Billing}
                                                   onChange={this.handleNormalInput}/>
                                    </FormField>
                                </FormRow>
                                <FormRow>
                                    <FormField width="two-thirds" label={`${T.translate("labels.country")} *`}>
                                        <FormSelect options={[{"label": "Italy", "value": "it"}]}
                                                    firstOption="Italia"
                                                    value="it"
                                                    disabled={true}/>
                                    </FormField>
                                    <FormField width="one-third" label={`${T.translate("labels.zip")} *`}
                                               className={`${errZipBilling && this.errorClass(errZipBilling)}`}>
                                        <FormInput width="one-third" name="zipBilling" value={this.state.zipBilling}
                                                   onChange={e => this.handleUserInputBilling(e, T.translate("labels.zip"))}/>
                                        {errZipBilling && this.errorLabel(errZipBilling)}
                                    </FormField>
                                    <FormField width="two-thirds" label={`${T.translate("labels.city")} *`}
                                               className={`${errCityBilling && this.errorClass(errCityBilling)}`}>
                                        <FormInput name="cityBilling" value={this.capFirstLetter(this.state.cityBilling)}
                                                   onChange={e => this.handleUserInputBilling(e, T.translate("labels.city"))}/>
                                        {errCityBilling && this.errorLabel(errCityBilling)}
                                    </FormField>
                                    <FormField width="one-third" label={`${T.translate("labels.state")} *`}
                                               className={`${errStateOrProvinceBilling && this.errorClass(errStateOrProvinceBilling)}`}>
                                        <FormInput name="stateOrProvinceBilling" value={this.capFirstLetter(this.state.stateOrProvinceBilling)}
                                                   onChange={e => this.handleUserInputBilling(e, T.translate("labels.state"))}/>
                                        {errStateOrProvinceBilling && this.errorLabel(errStateOrProvinceBilling)}
                                    </FormField>
                                </FormRow>
                            </div>
                        }
                        <FormRow>
                            <Button size="lg" type="success"
                                    disabled={(this.state.addedAddressCheck && this.state.acceptPrivacyAddress1Check) ? !this.state.formValid : !(this.state.formValid && this.state.formValidBilling)}
                                    onClick={this.saveDataShipping}
                                    style={{marginTop: 20}}>
                                {T.translate("labels.submitAction")}</Button>
                        </FormRow>
                    </Col>
                </Row>
            </Card>
        )
    }
}

export default CompleteOrder;


// WEBPACK FOOTER //
// ./src/components/CompleteOrder.js